<div class="image-viewer-wrapper">
  @if (imageLoaded) {
    <figure>
      <img
        [src]="src"
        [alt]="alt"
        [style.width]="calculatedImageDimension?.width+'px'"
        [style.height]="calculatedImageDimension?.height+'px'">
    </figure>
  } @else {
    <div class="img-loading-spinner-container">
      <mat-spinner />
    </div>
  }

  @if (!hideCloseBtn) {
    <div class="image-view-close-button">
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
